import React, { useMemo, useState } from "react";

import {
  RowReviewContext,
  type RowReviewContextValue,
  type RowReviewPayload,
} from "./rowReviewContext";

// Provider for the row-review bridge (7HAI-349). Holds the published parse
// payload in state so the calc card and the dedicated row-review page (sibling
// routes) share it across navigation. See ./rowReviewContext for the rationale.
export const RowReviewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [payload, setPayload] = useState<RowReviewPayload | null>(null);
  const value = useMemo<RowReviewContextValue>(() => ({ payload, setPayload }), [payload]);
  return <RowReviewContext value={value}>{children}</RowReviewContext>;
};
